import { Injectable } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { getDefaultControlValue, LawPersonType } from '@gk/gk-modules';
import { ECSControlName } from '../../../../components/electronic-correspondence-statement/models/form/form.model';
import { InvestorDetailsFormService } from '../../../../services/investor-details-form/investor-details-form.service';
import { BaseNewRequestFormService } from '../../../../shared/base-new-request-form/base-new-request-form.service';
import { GRPPortal } from '../portals/portals.model';
import {
  GRPNewGrantRequestControlName,
  GRPNewGrantRequestFormGroup,
  GRPPermissionControlName,
  GRPPermissionFormGroup,
} from './new-grant-request-form.model';

@Injectable()
export class GRPNewGrantRequestFormService {
  constructor(
    private formBuilder: UntypedFormBuilder,
    private baseNewRequestFormService: BaseNewRequestFormService,
    private investorDetailsFormService: InvestorDetailsFormService,
  ) {}

  getFormGroup(): FormGroup<GRPNewGrantRequestFormGroup> {
    return this.formBuilder.group({
      ...this.baseNewRequestFormService.getCommonFormGroup({
        [GRPNewGrantRequestControlName.ProxyDetailsCheckbox]: false,
        [GRPNewGrantRequestControlName.ContactData]: true,
        [ECSControlName.ElectronicCorrespondenceStatement]: false,
      }).controls,
      [GRPNewGrantRequestControlName.LawPerson]:
        this.baseNewRequestFormService.getFirstAndLastNameFormGroup(),
      [GRPNewGrantRequestControlName.Permission]: this.formBuilder.array([]),
      [GRPNewGrantRequestControlName.PortalIds]: [
        getDefaultControlValue(),
        Validators.required,
      ],
    });
  }

  getPermissionFormGroup(item: GRPPortal): FormGroup<GRPPermissionFormGroup> {
    return this.formBuilder.group({
      [GRPPermissionControlName.PortalName]: item.name,
      [GRPPermissionControlName.PortalId]: item.id,
      [GRPPermissionControlName.PermissionNumber]: [
        getDefaultControlValue(!item.isPermissionNumberRequired),
        item.isPermissionNumberRequired ? Validators.required : null,
      ],
      [GRPPermissionControlName.LegalBasis]: [
        getDefaultControlValue(item.isPermissionNumberRequired),
        item.isPermissionNumberRequired ? null : Validators.required,
      ],
      [GRPPermissionControlName.IsPermissionNumberRequired]:
        item.isPermissionNumberRequired,
      [GRPPermissionControlName.Entity]:
        this.investorDetailsFormService.getFormGroup(
          false,
          undefined,
          undefined,
          false,
          LawPersonType.Legal,
        ),
      [GRPPermissionControlName.TermsAndConditionsAcceptance]: [
        getDefaultControlValue(!item.isTermsAndConditionsFileAvailable),
        item.isTermsAndConditionsFileAvailable ? Validators.requiredTrue : null,
      ],
      [GRPPermissionControlName.IsTermsAndConditionsFileAvailable]:
        item.isTermsAndConditionsFileAvailable,
      [GRPPermissionControlName.Documents]: [item.documents],
    });
  }
}
